<p-card>
  <ng-template pTemplate="title">
    <div class="flex items-center gap-3">
      <p-button icon="pi pi-arrow-left" size="small" (onClick)="back()" />
      <h1>Edition d'un utilisateur</h1>
    </div>
  </ng-template>
  @if (user) {
    <form [formGroup]="userForm" class="mt-5 flex flex-col items-end relative">
      <div class="flex mb-5 w-full">
        <div class="flex flex-col gap-8 w-1/2">
          <p-floatLabel>
            <input
              class="w-full readonly-field"
              pInputText
              id="firstname"
              formControlName="firstname"
              readonly
            />
            <label for="firstname">Prénom</label>
          </p-floatLabel>
          <p-floatLabel>
            <input
              class="w-full readonly-field"
              pInputText
              id="lastname"
              formControlName="lastname"
              readonly
            />
            <label for="lastname">Nom</label>
          </p-floatLabel>
          <p-floatLabel>
            <input
              class="w-full readonly-field"
              pInputText
              id="initials"
              formControlName="initials"
              readonly
            />
            <label for="initials">Initiales</label>
          </p-floatLabel>
          <p-floatLabel>
            <input
              class="w-full readonly-field"
              pInputText
              id="email"
              formControlName="email"
              readonly
            />
            <label for="email">Email</label>
          </p-floatLabel>
          <div>
            @let marketsTypes = marketsTypes$ | async;
            @if (marketsTypes && marketsTypes.length > 0) {
              <div class="custom-tabs horizontal-tabs ms-[83px]">
                <ul class="tab-nav">
                  @for (
                    marketType of marketsTypes;
                    track marketType.id;
                    let i = $index
                  ) {
                    <li [class.active]="activeMarketTypeIndex === i">
                      <a (click)="selectMarketType(i)">{{
                        marketType.label
                      }}</a>
                    </li>
                  }
                </ul>
              </div>
            }
            <div class="flex">
              <div class="custom-tabs vertical-tabs mt-3">
                <ul class="tab-nav">
                  @for (
                    society of mlSocieties;
                    track society.id;
                    let i = $index
                  ) {
                    <li [class.active]="activeMlSocietyIndex === i">
                      <a (click)="selectMlSociety(i)">
                        <i [class]="society.icon"></i>
                      </a>
                    </li>
                  }
                </ul>
              </div>
              @let filteredProducts = filteredProducts$ | async;
              <div class="w-full flex flex-col bg-[#0A0B0B] p-3 mt-3 ms-3">
                <div class="flex justify-end mb-2 gap-2">
                  <p-button
                    icon="pi pi-check-square"
                    pTooltip="Tout sélectionner"
                    tooltipPosition="top"
                    size="small"
                    severity="secondary"
                    (onClick)="selectAllProducts(filteredProducts)"
                  ></p-button>
                  <p-button
                    icon="pi pi-times-circle"
                    pTooltip="Tout désélectionner"
                    tooltipPosition="top"
                    size="small"
                    severity="secondary"
                    (onClick)="deselectAllProducts(filteredProducts)"
                  ></p-button>
                </div>
                <div
                  class="flex flex-wrap gap-2"
                  [ngClass]="{
                    'items-center justify-center':
                      filteredProducts && filteredProducts.length === 0,
                  }"
                >
                  @for (product of filteredProducts; track product.id) {
                    <app-product-tag
                      [product]="product"
                      [isSelected]="isSelected(product)"
                      (onSelect)="addSelectedProduct(product)"
                      (onUnselect)="removeSelectedProduct(product)"
                    />
                  } @empty {
                    <div>AUCUN PRODUIT</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <p-divider layout="vertical" />
        <div
          class="flex-grow leafletMap"
          leaflet
          [leafletOptions]="options"
          [leafletLayers]="layers"
        ></div>
      </div>
      <div class="w-full mb-5">
        <div class="work-hours-panel bg-[#0A0B0B] p-4 rounded">
          <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
            <div class="flex items-baseline gap-3">
              <h2 class="text-lg font-semibold m-0">
                <i class="pi pi-clock me-2"></i>Horaires de travail
              </h2>
              <span class="text-sm text-gray-400">
                {{ totalWeeklyHours }}h / semaine
              </span>
            </div>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-refresh"
                label="Réinitialiser"
                size="small"
                severity="secondary"
                [text]="true"
                pTooltip="Restaurer les horaires par défaut"
                tooltipPosition="top"
                (onClick)="resetWorkHoursToDefaults()"
              />
              <p-button
                icon="pi pi-copy"
                label="Lun → Ven"
                size="small"
                severity="secondary"
                [text]="true"
                pTooltip="Appliquer le lundi à tous les jours ouvrés"
                tooltipPosition="top"
                (onClick)="copyDayToWeekdays('monday')"
              />
            </div>
          </div>

          <div
            class="grid grid-cols-1 md:grid-cols-2 gap-2"
            formGroupName="workHours"
          >
            @for (day of workDays; track day.key) {
              <div
                class="day-row flex items-center gap-3 p-2 rounded transition-opacity"
                [class.opacity-50]="!isDayEnabled(day.key)"
                [formGroupName]="day.key"
              >
                <div class="flex items-center gap-2 w-32 shrink-0">
                  <p-checkbox
                    formControlName="enabled"
                    [binary]="true"
                    [inputId]="'enabled-' + day.key"
                  />
                  <label
                    [for]="'enabled-' + day.key"
                    class="cursor-pointer select-none font-medium"
                  >
                    {{ day.label }}
                  </label>
                </div>

                @if (isDayEnabled(day.key)) {
                  <div class="flex items-center gap-2 flex-1">
                    <input
                      type="time"
                      pInputText
                      formControlName="start"
                      class="time-input"
                    />
                    <span class="text-gray-400">—</span>
                    <input
                      type="time"
                      pInputText
                      formControlName="end"
                      class="time-input"
                    />
                    @if (getDayGroup(day.key).hasError('endBeforeStart')) {
                      <i
                        class="pi pi-exclamation-triangle text-red-500"
                        pTooltip="L'heure de fin doit être après l'heure de début"
                        tooltipPosition="top"
                      ></i>
                    }
                  </div>
                  <div
                    class="flex items-center gap-2 shrink-0"
                    [class.text-purple-400]="isHotelDay(day.key)"
                  >
                    <p-checkbox
                      formControlName="hotel"
                      [binary]="true"
                      [inputId]="'hotel-' + day.key"
                    />
                    <label
                      [for]="'hotel-' + day.key"
                      class="cursor-pointer select-none flex items-center gap-1 text-sm"
                      pTooltip="Nuit à l'hôtel le soir de ce jour : pas de trajet dernière intervention → domicile ce soir, ni de trajet domicile → 1ère intervention le lendemain matin."
                      tooltipPosition="top"
                    >
                      <i class="pi pi-building"></i>
                      Hôtel
                    </label>
                  </div>
                } @else {
                  <span class="text-gray-500 italic flex-1">Repos</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <p-button
        (onClick)="submit()"
        [disabled]="userForm.invalid"
        [loading]="loading"
        type="submit"
        label="Enregistrer"
        size="small"
      />
    </form>
  } @else {
    <div class="grid place-items-center">
      <p-progressSpinner
        ariaLabel="loading"
        styleClass="w-4rem h-4rem"
        strokeWidth="5"
      />
    </div>
  }
</p-card>
